import { render, staticRenderFns } from "./SectionChatbots.vue?vue&type=template&id=090e73ce&scoped=true&"
import script from "./SectionChatbots.vue?vue&type=script&lang=js&"
export * from "./SectionChatbots.vue?vue&type=script&lang=js&"
import style0 from "./SectionChatbots.vue?vue&type=style&index=0&id=090e73ce&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090e73ce",
  null
  
)

export default component.exports